import Creator from "./Creator";
import Video from "./Video";

// eslint-disable-next-line import/no-anonymous-default-export
export default { Creator, Video };
